import React, { useState, useEffect } from "react";
import { firefunctions } from "../../../components/firebase/FirebaseProvider";
import { useHistory } from "react-router-dom";
import Header from "../../../components/molecules/Header";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import TabPanel from "../../../components/TabPanel";
import useStyles from "./style";
import Avatar from "@material-ui/core/Avatar";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import Skeleton from "@material-ui/lab/Skeleton";

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const SkeletonLoader = () => {
  const classes = useStyles();

  const data = [1, 2, 3, 4, 5, 6];
  return (
    <>
      {data?.map((value) => (
        <>
          <div className={classes.body}>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              <div className={classes.wrapIcon}>
                <Skeleton variant="circle" width={35} height={35} />
              </div>
              <div style={{ width: "20%", paddingLeft: "15px" }}>
                <Skeleton variarn="text" />
                <Skeleton variarn="text" />
              </div>
            </div>
          </div>
          <Divider />
        </>
      ))}
    </>
  );
};

function ListItemHistory({ value, data, loading }) {
  const classes = useStyles();
  const dataHistory = (() => {
    let datas = [];
    if (value == "tersedia") {
      datas = data?.filter((a) => a.Status == "Claim");
    } else {
      datas = data?.filter((a) => a.Status != "Claim");
    }
    return datas;
  })();

  return (
    <TabPanel value={value} index={value}>
      <List>
        {loading ? (
          <SkeletonLoader />
        ) : dataHistory.length > 0 ? (
          dataHistory?.map((item) => (
            <>
              <ListItem button>
                <ListItemAvatar>
                  <Avatar alt={item?.name} src={item?.image} />
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <Typography className={classes.liquidPrimary}>
                      {item?.name}
                    </Typography>
                  }
                  secondary={
                    <div>
                      {value == "tersedia" ? (
                        <Typography className={classes.liquidSecondList}>
                          Berlaku sampai {item?.expDate ?? "-"}
                        </Typography>
                      ) : (
                        <Typography className={classes.liquidSecondList}>
                          status : {item?.Status ?? "-"}
                        </Typography>
                      )}
                    </div>
                  }
                />
              </ListItem>
              <Divider />
            </>
          ))
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
              alignItems: "center",
              marginTop: "2.5%",
            }}
          >
            <Typography className={classes.liquidPrimary}>
              Tidak Ada Data
            </Typography>
          </div>
        )}
      </List>
    </TabPanel>
  );
}

function VocherHistory() {
  const classes = useStyles();
  const history = useHistory();
  const [tabValue, setTabValue] = useState("tersedia");

  const [tabs, setTabs] = useState([
    {
      label: "Voucher Tersedia",
      value: "tersedia",
    },
    {
      label: "Voucher Terdahulu",
      value: "terdahulu",
    },
  ]);

  const handleChange = (event, value) => {
    setTabValue(value);
  };

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const getData = async () => {
    setLoading(true);
    try {
      const funcList = await firefunctions.httpsCallable("inpoin-myVoucher")();
      setData(funcList?.data?.data ?? []);
      setLoading(false);
    } catch (error) {
      if (error) {
        const loginInpoin = async () => {
          try {
            await firefunctions.httpsCallable("inpoin-login");
            setLoading(false);
          } catch (error) {
            console.log("-loginInpoin", error);
          }
        };
        loginInpoin();
      }
      console.log("-listVoucher", error.message);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <Header
        type="with-title"
        title="Voucher History"
        onClick={() => history.push("/")}
      />

      <div className={classes.wrapRiwayat}>
        <Tabs
          variant="fullWidth"
          aria-label="full width tabs example"
          textColor="primary"
          value={tabValue || "tersedia"}
          onChange={handleChange}
          TabIndicatorProps={{
            style: {
              background: "rgb(86,117,211)",
              background:
                "linear-gradient(90deg, rgba(86,117,211,1) 70%, rgba(249,163,61,1) 70%, rgba(249,163,61,1) 90%, rgba(244,84,141,1) 90%)",
            },
          }}
          size="small"
        >
          {tabs.map((tab) => (
            <Tab
              className={classes.tab}
              key={tab.value}
              label={tab.label}
              value={tab.value}
              {...a11yProps(tab.value)}
            />
          ))}
        </Tabs>
        <ListItemHistory value={tabValue} data={data} loading={loading} />
      </div>
    </>
  );
}

export default VocherHistory;
